import React from 'react';
import { withRouter } from 'react-router-dom';
import SortableList from '../shared/SortableList';
import ListItemClient from '../shared/ListItemClient';
import Pagination from '../shared/Pagination';
import { clientAPI } from '../../InterfaceAPI/clientAPI';

class ClientServicesList extends React.Component {
  state = {
    services: [],
    sortBy: [],
    pagination: {},
    isLoading: false
  };

  render() {
    const { columns } = this.props;
    const { sortBy, services, pagination } = this.state;
    if (this.state.isLoading) return <p className="p">Loading...</p>;

    // we may need to create a new component for this after all due to the mobile designs on this element
    return (
      <div className="cms__list-wrap">
        <SortableList
          columns={columns}
          rows={services}
          sort={sortBy}
          ListItem={ListItemClient}
          isLoading={false}
          handleSort={() => console.log('no sorting here')}
          currentRoute={this.props.location.pathname}
          isPast={['past', 'past_all'].includes(this.props.filter)}
          isClientList={true}
        />

        <div className="cms__pagination">
          <Pagination
            pageCount={pagination.total_pages || 1}
            forcePage={pagination.current_page - 1 || 0}
            onPageChange={this.handlePaginate}
          />
        </div>
      </div>
    );
  }

  handlePaginate = ({ selected: page }) => {
    this.loadClientServices(this.props.client.id, page + 1);
  };

  loadClientServices(id, page = 1) {
    const { perPage: per_page = 25 } = this.props;
    this.setState({ isLoading: true });
    clientAPI
      .getClientServices(id, {
        filter: this.props.filter || 'past',
        page,
        per_page
      })
      .then(({ services, pagination }) => {
        const results = [...services];
        // REmove Select Menu  Option
        let clientServices = !this.props.max ? results : results.slice(0, 4);

        this.setState({
          services: clientServices,
          pagination,
          isLoading: false
        });
      })
      .catch(err => console.log(err));
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.client.id !== prevProps.client.id)
      this.loadClientServices(this.props.client.id);
  }

  componentDidMount() {
    const { client } = this.props;
    if (client && client.id > 0) this.loadClientServices(client.id);
  }
}

export default withRouter(ClientServicesList);



// WEBPACK FOOTER //
// ./src/components/client/ClientServicesList.js